import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./locales/en/translation.json";
import esTranslation from "./locales/es/translation.json";
import { persistLanguageFromQueryParam } from "./languagePreference";

// Persist a ?lang= preference before detection runs. This is deliberately not
// feature-flag gated — the displayed language is gated separately in
// AppContainer, which forces English while the Spanish toggle flag is off.
persistLanguageFromQueryParam();

export const defaultNS = "translation";
export const resources = {
  en: {
    translation: enTranslation,
  },
  es: {
    translation: esTranslation,
  },
} as const;

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: "en",
    debug: import.meta.env.DEV,
    defaultNS,

    detection: {
      // Order of detection methods
      order: ["querystring", "localStorage", "navigator"],
      // Persistence is handled explicitly (query param above, feature-flagged
      // switcher actions) rather than by the detector.
      caches: [],
      // Query parameter name
      lookupQuerystring: "lang",
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
